import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkAddClinic } from '../types';
import withUploadedLogo from './withUploadedLogo';

const onAddClinic: IThunkAddClinic = thunk(async (_, data) => {
  const payload = await withUploadedLogo(data);
  await api.clinic.addClinic(payload);
});

export default onAddClinic;
